/**
 * Shared application state for cooperative cancellation.
 * Uses both a flag (for checkCancel) and an AbortController (for instant fetch abort).
 * @module state
 */

let cancelRequested = false;
let abortController = null;

/**
 * Returns whether cancellation has been requested.
 * @returns {boolean}
 */
export function isCancelRequested() {
  return cancelRequested;
}

/**
 * Requests cancellation and aborts any pending fetch requests.
 */
export function requestCancel() {
  cancelRequested = true;
  if (abortController) abortController.abort();
}

/**
 * Resets the cancellation flag and creates a new AbortController.
 * Call at the start of each import.
 * @returns {AbortSignal} Signal to pass to fetch calls
 */
export function resetCancel() {
  cancelRequested = false;
  abortController = new AbortController();
  return abortController.signal;
}

/**
 * Returns the current AbortSignal, or null.
 * @returns {AbortSignal|null}
 */
export function getAbortSignal() {
  return abortController ? abortController.signal : null;
}

/**
 * Throws if cancellation has been requested.
 * Call at strategic points during long operations.
 * @throws {Error} With message "__CANCEL__"
 */
export function checkCancel() {
  if (cancelRequested) throw new Error("__CANCEL__");
}
